import { Component, Input } from '@angular/core';
import { MatExpansionPanel } from '@angular/material/expansion';

@Component({
    selector: 'app-footer-accordion',
    templateUrl: './footer-accordion.component.html',
    styleUrls: ['./footer-accordion.component.scss'],
    standalone: false,
})
export class FooterAccordionComponent {
    public openState = false;

    @Input() displayHandler = false;

    expandPanel(matExpansionPanel: MatExpansionPanel, event): void {
        event.stopPropagation();

        if (!this.openState) {
            matExpansionPanel.close();
        } else {
            matExpansionPanel.open();
        }
    }

    handlerFooter(): void {
        this.openState = !this.openState;
    }
}
